<template>
  <div>
    <el-form ref="form" size="mini" :model="formData" :rules="rules">
      <el-row :gutter="10" class="mb-2 mt-2">
        <el-col :span="24">
          <span class="span_text">
            {{ $l('form_label_production_factory') || '采购工厂' }}：{{
              scmName
            }}
          </span>
        </el-col>
      </el-row>
      <el-row :gutter="10">
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_salesPerson') || '业务开发'"
            prop="salesPersonCode"
          >
            <dict-select
              v-model="formData.salesPersonCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="
                $l('form_placeholder_salesPerson') || '请选择业务开发'
              "
              :selectedLabel.sync="formData.salesPersonName"
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_buyerCode') || '跟单'"
            prop="buyerCode"
          >
            <dict-select
              v-model="formData.buyerCode"
              url="/master/common/dict/baseUserSelect"
              :placeholder="$l('form_placeholder_buyerCode') || '请选择跟单'"
              :selectedLabel.sync="formData.buyerName"
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_purchaseDate') || '采购日期'"
            prop="purchaseDate"
          >
            <el-date-picker
              v-model="formData.purchaseDate"
              type="date"
              value-format="yyyy-MM-dd"
              :placeholder="
                $l('form_placeholder_purchaseDate') || '请选择采购日期'
              "
              style="width: 100%"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_importanceLevel') || '订单性质'"
            prop="importanceLevel"
          >
            <dict-select
              v-model="formData.importanceLevel"
              url="/master/common/dict/biz"
              :body="{ dictType: 'importanceLevel' }"
              :placeholder="
                $l('form_placeholder_importanceLevel') || '请选择订单性质'
              "
              clearable
              filterable
              size="mini"
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_quotedMethod') || '报价方式'"
            prop="quotedMethod"
          >
            <dict-select
              v-model="formData.quotedMethod"
              url="/sys/common/dict/system"
              :body="{ dictType: 'quotedMethod' }"
              :placeholder="
                $l('form_placeholder_quotedMethod') || '请选择报价方式'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
        <!-- <el-col :span="8">
          <el-form-item
            :label="$l('form_label_currencyUnit') || '货币单位'"
            prop="currencyUnit"
          >
            <dict-select
              v-model="formData.currencyUnit"
              url="/master/common/dict/biz"
              :body="currencyUnitParams"
              :placeholder="
                $l('form_placeholder_currencyUnit') || '请选择货币单位'
              "
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col> -->

        <el-col :span="16">
          <el-form-item
            :label="$l('form_label_takeOrderOrgCode') || '国内接单公司'"
            prop="takeOrderOrgCode"
          >
            <dict-select
              v-model="formData.takeOrderOrgCode"
              url="/sys/common/dict/system"
              :body="takeOrderOrgCodeParams"
              :placeholder="
                $l('form_placeholder_takeOrderOrgCode') || '请选择国内接单公司'
              "
              size="mini"
              clearable
              filterable
            />
          </el-form-item>
        </el-col>

        <el-col :span="8">
          <el-form-item
            :label="$l('form_label_factoryPaymentTerms') || '工厂付款方式'"
            prop="factoryPaymentTerms"
          >
            <dict-select
              v-model="formData.factoryPaymentTerms"
              url="/master/common/dict/biz"
              :body="{ dictType: 'paymentTerms' }"
              :placeholder="
                $l('form_placeholder_factoryPaymentTerms') ||
                  '请选择工厂付款方式'
              "
              style="width: 100%"
              size="mini"
              filterable
              clearable
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close()" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save()" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from 'dayjs'
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  props: {
    params: { type: Object, default: () => {} },
  },
  data() {
    return {
      formData: {
        salesPersonCode: '',
        salesPersonName: '',
        buyerCode: '',
        buyerName: '',
        purchaseDate: dayjs().format('YYYY-MM-DD'),
        currencyUnit: 'CNY',
        quotedMethod: 'FOB',
      },
      backDialogVisible: false,
      currencyUnitParams: { dictType: 'currencyUnit' },
      takeOrderOrgCodeParams: { dictType: 'takeOrderOrgCode' },
      rules: {
        salesPersonCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_salesPerson') || '请选择业务开发',
            trigger: 'change',
          },
        ],
        buyerCode: [
          {
            required: true,
            message: this.$l('form_placeholder_buyerCode') || '请选择跟单',
            trigger: 'change',
          },
        ],
        purchaseDate: [
          {
            required: true,
            message:
              this.$l('form_placeholder_purchaseDate') || '请选择采购日期',
            trigger: 'change',
          },
        ],
        currencyUnit: [
          {
            required: true,
            message:
              this.$l('form_placeholder_currencyUnit') || '请选择货币单位',
            trigger: 'change',
          },
        ],
        takeOrderOrgCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_takeOrderOrgCode') ||
              '请选择国内接单公司',
            trigger: 'change',
          },
        ],
        importanceLevel: [
          {
            required: true,
            message:
              this.$l('form_placeholder_importanceLevel') || '请选择订单性质',
            trigger: 'change',
          },
        ],
        quotedMethod: [
          {
            required: true,
            message:
              this.$l('form_placeholder_quotedMethod') || '请选择报价方式',
            trigger: 'change',
          },
        ],
        factoryPaymentTerms: [
          {
            required: true,
            message:
              this.$l('form_placeholder_factoryPaymentTerms') ||
              '请选择工厂付款方式',
            trigger: 'change',
          },
        ],
      },
    }
  },
  computed: {
    scmName() {
      return this.params.checkedRows[0].scmName
    },
  },
  watch: {
    params: {
      handler(info) {
        const {
          salesPersonCode,
          salesPersonName,
          merchandiserCode,
          merchandiserName,
        } = info.checkedRows[0]

        this.formData.salesPersonCode = salesPersonCode
        this.formData.salesPersonName = salesPersonName
        this.formData.buyerCode = merchandiserCode
        this.formData.buyerName = merchandiserName
      },
      immediate: true,
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)
      if (this.loadingOpen()) return

      const params = { ...this.formData, ...this.params }
      const res = await this.$api
        .ecomEvgBulkOrderPurchaseGenerateApi(params)
        .catch(() => null)
      this.loadingClose()
      if (!res) return
      const { status } = res
      if (status !== 200) {
        this.$message.error(this.$l('INDEX.tips_operate_no') || '操作失败！')
        return
      }
      this.$message({
        showClose: true,
        message: this.$l('INDEX.tips_operate_ok') || '操作成功！',
        type: 'success',
      })
      this.close()
      this.$emit('reload')
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
  },
}
</script>
<style lang="scss" scoped>
.span_text {
  font-size: 16px;
  color: #101010;
  font-weight: 600;
}
</style>
